import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import { Seo } from '../shared';
import SearchBar from './SearchBar';
import FlightList from './FlightList';
import FlightsNepalPayStrip from './FlightsNepalPayStrip';
import { resetFlightSearch } from '../../redux/actions';
import './flights.scss';

function FlightsPage({ searchDetails, flights, resetFlightSearch: clearSearch }) {
	// Stale failed search (criteria set, no results): show fresh search form when revisiting /flights.
	useLayoutEffect(() => {
		const hasCriteria =
			searchDetails?.strSectorFrom &&
			searchDetails?.strSectorTo &&
			searchDetails?.strNationality;
		const hasResults = (flights?.outbounds?.length || 0) > 0;
		if (hasCriteria && !hasResults) {
			clearSearch();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount
	}, []);

	const hasSearch = Boolean(
		searchDetails?.strSectorFrom && searchDetails?.strSectorTo && searchDetails?.strNationality
	);

	return (
		<div className="flights-page flights-page--booking">
			<Seo
				title="Book Domestic Flights in Nepal"
				path="/flights"
				description="Book Nepal domestic flights online with your foreign Visa, Mastercard, or Amex. Pay in USD or NPR — no Nepali wallet required."
			/>

			<header className="flights-page__hero flights-page__hero--compact" role="presentation" />

			<div className="container flights-page__body pb-5">
				{!hasSearch ? (
					<div className="flights-search-panel">
						<FlightsNepalPayStrip panelTop />
						<div className="flights-search-panel__form-wrap">
							<h1 className="flights-search-panel__title">Search domestic flights</h1>
							<SearchBar />
						</div>
					</div>
				) : (
					<>
						<h1 className="sr-only">Domestic flight search results</h1>
						<FlightList />
					</>
				)}
			</div>
		</div>
	);
}

export default connect(
	({ flightStore }) => ({
		searchDetails: flightStore.searchDetails,
		flights: flightStore.flights,
	}),
	{ resetFlightSearch }
)(FlightsPage);
